import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=d946fad8&scoped=true&"
import script from "./FontSelect.vue?vue&type=script&lang=js&"
export * from "./FontSelect.vue?vue&type=script&lang=js&"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=d946fad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d946fad8",
  null
  
)

export default component.exports